import { render } from "./about.vue?vue&type=template&id=3d4d3292&scoped=true&ts=true"
import script from "./about.vue?vue&type=script&lang=ts"
export * from "./about.vue?vue&type=script&lang=ts"

import "./about.vue?vue&type=style&index=0&id=3d4d3292&lang=less&scoped=true"

import exportComponent from "/Users/julianzeng/Desktop/Buz/mainland/fuwangleyou-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4d3292"]])

export default __exports__